import { Route, Navigate } from "react-router-dom";
import Protected from "../components/Protected";
// eslint-disable-next-line no-unused-vars
import ClientAdminProtected from "../components/ClinetAdminProtected";
import Organization from "../pages/Admin-pages/CA-admin-pages/Organization";
import Subscription from "../pages/Admin-pages/CA-admin-pages/Subscrption";
import Relationships from "../pages/Admin-pages/CA-admin-pages/Relationships";
import StructureCA from "../pages/Admin-pages/CA-admin-pages/StructureCA";
import ContactAddCA from "../pages/Admin-pages/CA-admin-pages/ContactAddCA";
import ContactEditCA from "../pages/Admin-pages/CA-admin-pages/ContactEditCA";
import Locations from "../pages/Admin-pages/CA-admin-pages/Locations";
import LogoUploader from "../pages/Admin-pages/CA-admin-pages/LogoUploader";
import ApiSettings from "../pages/Admin-pages/CA-admin-pages/ApiSettings";
import {
  getUpdateStatus,
  getViewStatus,
} from "../components/AdminComponents/ViewUpdateIndex";
import { useSelector } from "react-redux";
import ClientDashboard from "../pages/Admin-pages/CA-admin-pages/Dashboard/ClientDashboard";
import AuditTrail from "../pages/Admin-pages/CA-admin-pages/Audit-Trail/AuditTrail";
import EmailTrail from "../pages/Admin-pages/CA-admin-pages/Audit-Trail/Email";
import TemplateListing from "../pages/Admin-pages/CA-admin-pages/Communications/TemplateListing";
import TemplateEdit from "../pages/Admin-pages/CA-admin-pages/Communications/TemplateEdit";
import Triggers from "../pages/Admin-pages/CA-admin-pages/Communications/Triggers";
import Logs from "../pages/Admin-pages/CA-admin-pages/Communications/Logs";
import AddTrigger from "../pages/Admin-pages/CA-admin-pages/Communications/AddTrigger";
import TemplateLogs from "../pages/Admin-pages/CA-admin-pages/Communications/TemplateLogs";
import AddTemplates from "../pages/Admin-pages/CA-admin-pages/Communications/AddTemplates";
import TriggerEdit from "../pages/Admin-pages/CA-admin-pages/Communications/TriggerEdit";
import ViewNotifications from "../pages/Admin-pages/CA-admin-pages/Communications/ViewNotifications";
import { env } from "../config";
import WorkRoleListing from "../pages/Admin-pages/CA-admin-pages/WorkRoleListing";
import DocustoreEmployees from "../pages/Admin-pages/CA-admin-pages/Docustore/DocustoreEmployees";
import DocustoreOrganization from "../pages/Admin-pages/CA-admin-pages/Docustore/DocustoreOrganization";

const CaAdminRoutes = () => {
  const userInfo = useSelector((state) => state?.user);

  const routes = [
    <Route
      key="ca-route-1"
      path="/ca-admin/organization/profile/details"
      element={
        <Protected>
          <ClientAdminProtected access={getViewStatus(userInfo, 0, 1)}>
            <Organization />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    <Route
      key="ca-route-2"
      path="/ca-admin/organization"
      element={<Navigate to="/ca-admin/organization/profile/dashboard" />}
    />,
    <Route
      key="ca-route-221"
      path="/ca-admin/organization/profile"
      element={<Navigate to="/ca-admin/organization/profile/dashboard" />}
    />,
    // New route for dashboard
    <Route
      key="ca-route-222"
      path="/ca-admin/organization/profile/dashboard"
      element={
        <Protected>
          <ClientAdminProtected access={true}>
            <ClientDashboard />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    // end new route
    <Route
      key="ca-route-13"
      path="/ca-admin/organization/profile/subscription"
      element={
        <Protected>
          <ClientAdminProtected access={getViewStatus(userInfo, 0, 2)}>
            <Subscription />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    <Route
      key="ca-route-14"
      path="/ca-admin/organization/profile/relationships"
      element={
        <Protected>
          <ClientAdminProtected access={getViewStatus(userInfo, 0, 3)}>
            <Relationships />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    <Route
      key="ca-route-15"
      path="/ca-admin/organization/profile/structure"
      element={
        <Protected>
          <ClientAdminProtected access={getViewStatus(userInfo, 0, 4)}>
            <StructureCA />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    <Route
      key="ca-route-15"
      path="/ca-admin/organization/profile/work-roles"
      element={
        <Protected>
          <ClientAdminProtected access={true}>
            <WorkRoleListing />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    <Route
      key="ca-route-16"
      path="/ca-admin/organization/profile/relationships/add-contact/:id"
      element={
        <Protected>
          <ClientAdminProtected access={getViewStatus(userInfo, 0, 3)}>
            <ContactAddCA />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    <Route
      key="ca-route-17"
      path="/ca-admin/organization/profile/relationships/edit-contact/:id/:mainID"
      element={
        <Protected>
          <ClientAdminProtected access={getViewStatus(userInfo, 0, 3)}>
            <ContactEditCA />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    <Route
      key="ca-route-118"
      path="/ca-admin/organization/profile/locations"
      element={
        <Protected>
          <ClientAdminProtected access={getViewStatus(userInfo, 0, 5)}>
            <Locations />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    <Route
      key="ca-route-18"
      path="/ca-admin/organization/settings/logo"
      element={
        <Protected>
          <ClientAdminProtected access={getViewStatus(userInfo, 1, 0)}>
            <LogoUploader />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    <Route
      key="ca-route-19"
      path="/ca-admin/organization/settings/login-settings"
      element={
        <Protected>
          <ClientAdminProtected access={getViewStatus(userInfo, 1, 1)}>
            <ApiSettings />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    <Route
      key="ca-route-218"
      path="/ca-admin/organization/settings"
      element={<Navigate to="/ca-admin/organization/settings/logo" />}
    />,
    <Route
      path="/ca-admin/organization/audit-trail/"
      element={<Navigate to="/ca-admin/organization/audit-trail/login" />}
    />,
    <Route
      key="ca-route-112"
      path="/ca-admin/organization/audit-trail/login"
      element={
        <Protected>
          <ClientAdminProtected access={getViewStatus(userInfo, 1, 0)}>
            <AuditTrail />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    <Route
      key="ca-route-1143"
      path="/ca-admin/organization/audit-trail/email"
      element={
        <Protected>
          <ClientAdminProtected access={getViewStatus(userInfo, 1, 0)}>
            <EmailTrail />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    <Route
      key="ca-route-1143ds"
      path="/ca-admin/organization/communications/templates"
      element={
        <Protected>
          <ClientAdminProtected access={getViewStatus(userInfo, 3, 0)}>
            <TemplateListing />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    <Route
      path="/ca-admin/organization/communications"
      element={
        <Navigate
          to={
            env === "prod"
              ? "/ca-admin/organization/communications/templates/"
              : "/ca-admin/organization/communications/notifications/"
          }
        />
      }
    />,
    <Route
      key="ca-route-1143ds"
      path="/ca-admin/organization/communications/templates/edit-template/:id"
      element={
        <Protected>
          <ClientAdminProtected access={getUpdateStatus(userInfo, 3, 0)}>
            <TemplateEdit />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    <Route
      key="ca-route-log-02"
      path="/ca-admin/organization/communications/templates/add-template/"
      element={
        <Protected>
          <ClientAdminProtected access={getViewStatus(userInfo, 3, 0)}>
            <AddTemplates />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    <Route
      key="ca-route-1144354"
      path="/ca-admin/organization/communications/triggers"
      element={
        <Protected>
          <ClientAdminProtected access={getViewStatus(userInfo, 3, 0)}>
            <Triggers />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    <Route
      key="ca-route-14435"
      path="/ca-admin/organization/communications/logs"
      element={
        <Protected>
          <ClientAdminProtected access={getViewStatus(userInfo, 3, 0)}>
            <Logs />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    <Route
      key="ca-route-14435"
      path="/ca-admin/organization/communications/triggers/add-trigger/:id"
      element={
        <Protected>
          <ClientAdminProtected access={getViewStatus(userInfo, 3, 0)}>
            <AddTrigger />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    <Route
      key="ca-route-14435"
      path="/ca-admin/organization/communications/triggers/edit-trigger/:id"
      element={
        <Protected>
          <ClientAdminProtected access={getViewStatus(userInfo, 3, 0)}>
            <TriggerEdit />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    <Route
      key="ca-route-log-0143"
      path="/ca-admin/organization/communications/templates/:id/logs"
      element={
        <Protected>
          <ClientAdminProtected access={getViewStatus(userInfo, 3, 0)}>
            <TemplateLogs />
          </ClientAdminProtected>
        </Protected>
      }
    />,

    <Route
      key="ca-route-log-0134new"
      path="/ca-admin/organization/communications/notifications/:id?"
      element={
        <Protected>
          <ClientAdminProtected access={getViewStatus(userInfo, 3, 0)}>
            <ViewNotifications />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    
    // Docustore Routes
    <Route
      key="ca-route-docustore-1"
      path="/ca-admin/organization/docustor"
      element={<Navigate to="/ca-admin/organization/docustor/employees" />}
    />,
     // <Route
    //   key="ca-route-docustore-2"
    //   path="/ca-admin/organization/docustor/employees"
    //   element={
    //     <Protected>
    //       <ClientAdminProtected access={getViewStatus(userInfo, 4, 0)}>
    //         <DocustoreEmployees />
    //       </ClientAdminProtected>
    //     </Protected>
    //   }
    // />,
    // <Route
    //   key="ca-route-docustore-3"
    //   path="/ca-admin/organization/docustor/organization"
    //   element={
    //     <Protected>
    //       <ClientAdminProtected access={getViewStatus(userInfo, 4, 1)}>
    //         <DocustoreOrganization />
    //       </ClientAdminProtected>
    //     </Protected>
    //   }
    // />,
    <Route
      key="ca-route-docustore-employees"
      path="/ca-admin/organization/docustor/employees"
      element={
        <Protected>
          <ClientAdminProtected access={getViewStatus(userInfo, 4, 0)}>
            <DocustoreEmployees />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    <Route
      key="ca-route-docustore-organization"
      path="/ca-admin/organization/docustor/organization"
      element={
        <Protected>
          <ClientAdminProtected access={getViewStatus(userInfo, 4, 1)}>
            <DocustoreOrganization />
          </ClientAdminProtected>
        </Protected>
      }
    />,
  ];
  return routes;
};
export default CaAdminRoutes;
